import { Box } from '@material-ui/core';
import { useEffect, useState } from 'react';
import SideButtonGroup from './SideButtonGroup';
import ResetButton from './ResetButton';
import layout from '../../styles/layout.module.css';
import typography from '../../styles/typography.module.css';
import { useTranslation } from 'react-i18next';

const SettingsSection = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const { t } = useTranslation();
    const handleWindowResize = () => {
        setWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', handleWindowResize);
        return () => window.removeEventListener('resize', handleWindowResize);
    }, []);

    return (
        <>
            {width < 750 ? (
                <></>
            ) : (
                <Box>
                    <h4 className={typography.headerTitle}>{t('settings.title')}</h4>
                </Box>
            )}
            <Box className={layout.settingsActionContainer}>
                <ResetButton />
                <SideButtonGroup />
            </Box>
        </>
    );
};

export default SettingsSection;
